module.exports = __webpack_public_path__ + "static/img/ACGCA tree time-course figure.00ea0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ACGCA tree time-course figure.png
// module id = EeTW
// module chunks = 1